import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-neworderconfirmation',
  templateUrl: './neworderconfirmation.component.html',
  styleUrls: ['./neworderconfirmation.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class NeworderconfirmationComponent implements OnInit {

  constructor(public parent: ManagementComponent, private managementService:ManagementServiceService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

    // Debounce search.
    this.searchTermUpdate.pipe(
      debounceTime(250),
      distinctUntilChanged())
      .subscribe(value => {
       this.Filter.SearchTerm = value;

       if(this.Filter.SearchTerm.length == 0){
        this.Partners = [];
        this.PartnersCount = 0;
       }
       else if((this.CurrentPartner?.ID?.length > 0) == false){
        this.GetPartnersFiltered();
       }
      });

      // Debounce search.
    this.countryTermUpdate.pipe(
      debounceTime(100),
      distinctUntilChanged())
      .subscribe(value => {
        this.filterCountriesBySearchTerm(value);
      });
  }

  searchTermUpdate = new Subject<string>();
  countryTermUpdate = new Subject<string>();
  SearchTerm:string;
  loadingShipment:boolean;

  Partners:any[];
  PartnersCount:number;
  CurrentPartner:any;

  Filter: {[k: string]: any} = {};
  NewPartnerAddress: {[k: string]: any} = {};

  Countries:any[];
  FilteredCountries:any[];
  loadingCountry:boolean;

  ShowAddNewPartner:boolean

  ngOnInit(): void {
    this.InitializeFilter();
    this.Countries = this.parent.masterData.Countries;
    this.GetShippingMasterData();
  }

  InitializeFilter(){

    this.Filter = {};
    this.Filter.SearchTerm = "";

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.Company = {};
    this.Filter.Company = null;
    
    this.Filter.Country = {};
    this.Filter.Country = null;
  }

  GetPartnersFiltered(){
    var request = {
      SearchTerm:this.Filter.SearchTerm,
      CountryID:this.Filter.Country?.ID,
      PageIndex:this.Filter.Pager.PageIndex,
      PageSize:this.Filter.Pager?.PageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.Filter.Company?.ID
    };

    this.loadingShipment = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.Filter.Pager.TotalCount = response["Count"];
      }
   
      this.loadingShipment = false;
    });
  }

  filterCountriesBySearchTerm(searchTerm: string): void {

    this.loadingCountry = true;

    this.FilteredCountries = this.Countries.filter(country => 
        country.Name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    this.loadingCountry = false;
  }

  DeselectPartner(){
    this.Filter.SearchTerm = "";
    this.CurrentPartner = {};
  }

  ShowAddNewPartnerContainer(){

    this.NewPartnerAddress = null;
    this.NewPartnerAddress = {};
    this.NewPartnerAddress.ID = 0;
    this.NewPartnerAddress.ContactCompany = this.Filter.SearchTerm;
    this.NewPartnerAddress.ContactPerson = "";
    this.NewPartnerAddress.VATNumber = "";

    this.NewPartnerAddress.Country = {};
    this.NewPartnerAddress.Country.ID = 0;

    this.NewPartnerAddress.State = "";
    this.NewPartnerAddress.City = "";
    this.NewPartnerAddress.AddressLine = "";
    this.NewPartnerAddress.ZipCode = "";
    this.NewPartnerAddress.Email = "";
    this.NewPartnerAddress.Phone = "";

    this.ShowAddNewPartner = true;
  }

  AddNewPartnerValid:boolean;
  LoadingAddNewPartnerFromShippingAddress:boolean = false;

  DeselectNewAddressCountry(){
    this.NewPartnerAddress.Country = [];
    this.ProofNewPartnerAddress();
  }

  ProofNewPartnerAddress(){
    if(this.NewPartnerAddress.ContactCompany.length > 0){
      if(this.NewPartnerAddress.ContactPerson.length > 0){
        if(this.NewPartnerAddress.Country.ID > 0){
          if(this.NewPartnerAddress.State.length > 0){
            if(this.NewPartnerAddress.City.length > 0){
              if(this.NewPartnerAddress.AddressLine.length > 0){
                if(this.NewPartnerAddress.ZipCode.length > 0){
                  if(this.NewPartnerAddress.Email.length > 0){
                    if(this.NewPartnerAddress.Phone.length > 0){
                      this.AddNewPartnerValid = true;
                    }
                    else{
                      this.AddNewPartnerValid = false;
                    }
                  }
                  else{
                    this.AddNewPartnerValid = false;
                  }
                }
                else{
                  this.AddNewPartnerValid = false;
                }
              }
              else{
                this.AddNewPartnerValid = false;
              }
            }
            else{
              this.AddNewPartnerValid = false;
            }
          }
          else{
            this.AddNewPartnerValid = false;
          }
        }
        else{
          this.AddNewPartnerValid = false;
        }
      }
      else{
        this.AddNewPartnerValid = false;
      }
    }
    else{
      this.AddNewPartnerValid = false;
    }
  }

  AddNewPartnerFromShippingAddress(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingAddress:this.NewPartnerAddress
    };
  
    this.LoadingAddNewPartnerFromShippingAddress = true;
  
    this.service.AddNewPartnerFromShippingAddress(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowAddNewPartner = false;
        this.CurrentPartner = response["Partner"];
        this.Filter.SearchTerm = this.NewPartnerAddress.ContactCompany;
      }
     
      this.GetPartner(this.CurrentPartner.ID);
      this.LoadingAddNewPartnerFromShippingAddress = false;
    });
  }

  GetPartner(id:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:id,
      WithAllData:true
    };

    this.parent.loading = true;

    this.service.GetPartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.CurrentPartner = response["Partner"];
      }
   
      this.parent.loading = false;
    });
  }

  InitializeNewAddressCountrySearch(){

    if((this.NewPartnerAddress?.Country?.ID > 0) == false){
      this.NewPartnerAddress.Country = {};
      this.FilteredCountries = this.Countries.slice(0, 10);
    }
}

SelectNewPartnerAddressCountry(c:any){
  this.NewPartnerAddress.Country = JSON.parse(JSON.stringify(c));
  this.FilteredCountries = [];
  this.ProofNewPartnerAddress();
}

ShippingResponsabilities:any[];
ShippingServiceTypes:any[];
ShippingWays:any[];
ShippingCompanies:any[];
WeightTypes:any[];
Directions:any[];
GeneralShippingServiceTypes:any[];
ShippingCompany:any;
ShippingDirection:any;
ShippingServiceType:any;


GetShippingMasterData(){
  var request = {
   User:this.parent.User,
   Language:this.parent.getLanguage()
 };

this.parent.loading = true;

this.managementService.GetShippingMasterData(request).subscribe(response => {

  if(response["Status"] != 1){
   this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
   this.ShippingResponsabilities = response["ShippingResponsabilities"];
   this.GeneralShippingServiceTypes = response["ShippingServiceTypes"];
   this.ShippingServiceTypes = response["ShippingServiceTypes"];
   this.ShippingWays = response["ShippingWays"];
   this.ShippingCompanies = response["APIShippingCompanies"];
   this.WeightTypes = response["WeightTypes"];
   this.Directions = response["Directions"];
  }

  this.parent.loading = false;
 });
 }

 SelectShippingCompany(s:any){
  this.ShippingCompanies.forEach(element => {
    if (element.ID === s.ID) {
      element.IsSelected = true;
    } else {
      element.IsSelected = false;
    }
  });

  this.ShippingCompany = s;
  this.GetShippingCompanyServiceTypes(this.ShippingCompany.ID);
 }

 GetShippingCompanyServiceTypes(CompanyID:number){
  var request = {
   User:this.parent.User,
   Language:this.parent.getLanguage(),
   CompanyID:CompanyID,
   PartnerID:this.CurrentPartner?.ID,
   DirectionID:this.ShippingDirection?.ID
 };

this.parent.loading = true;

this.managementService.GetShippingCompanyServiceTypes(request).subscribe(response => {

  if(response["Status"] != 1){
   this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
    this.ShippingCompany.ShippingServiceTypes = response["ShippingServiceTypes"];
    this.ShippingServiceType = this.ShippingCompany.ShippingServiceTypes.filter(x => x.IsSelected == true)[0];
  }

  this.parent.loading = false;
  });
}

SelectShippingDirection(d:any){
  this.ShippingDirection = JSON.parse(JSON.stringify(d));
}

SelectShippingServiceType(s:any){
  if(s != null){
    this.ShippingServiceType = JSON.parse(JSON.stringify(s));
    this.ShippingServiceType.IsSelected = true;

    this.ShippingCompany.ShippingServiceTypes.forEach(element => {
      element.IsSelected = false;
    });

    this.ShippingCompany.ShippingServiceTypes.filter(x => x.ID == this.ShippingServiceType.ID)[0].IsSelected = true;
  }
  else{
    this.ShippingCompany.ShippingServiceTypes = [];
  }
}

SelectPartner(p:any){
  this.CurrentPartner = JSON.parse(JSON.stringify(p));
  this.Filter.SearchTerm = this.CurrentPartner.Name;
  this.Partners = [];
  this.SelectPartnerForNewOrder(this.CurrentPartner);
}

SelectPartnerForNewOrder(partner:any){
  var request = {
   User:this.parent.User,
   Language:this.parent.getLanguage(),
   Partner:partner,
 };

this.parent.loading = true;

this.managementService.SelectPartnerForNewOrder(request).subscribe(response => {

  if(response["Status"] != 1){
   this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
    this.CurrentPartner = response["Partner"];
  }

  this.parent.loading = false;
  });
}

}
